var map = {
	"./404.svg": 3044,
	"./back.svg": 1630,
	"./bug.svg": 1167,
	"./build.svg": 6591,
	"./button.svg": 5658,
	"./cascader.svg": 1723,
	"./chart.svg": 4318,
	"./checkbox.svg": 6698,
	"./circle.svg": 3851,
	"./circleA.svg": 8272,
	"./clipboard.svg": 7895,
	"./code.svg": 2878,
	"./color.svg": 2073,
	"./component.svg": 23,
	"./dashboard.svg": 8987,
	"./date-range.svg": 4968,
	"./date.svg": 2902,
	"./dict.svg": 3413,
	"./documentation.svg": 2198,
	"./download.svg": 4880,
	"./drag.svg": 5358,
	"./druid.svg": 8981,
	"./edit.svg": 6830,
	"./education.svg": 2838,
	"./email.svg": 1262,
	"./example.svg": 6097,
	"./excel.svg": 9972,
	"./exit-fullscreen.svg": 2837,
	"./eye-open.svg": 8662,
	"./eye.svg": 3735,
	"./form.svg": 3536,
	"./fullscreen.svg": 9589,
	"./github.svg": 9879,
	"./guide.svg": 1336,
	"./icon.svg": 6680,
	"./input.svg": 124,
	"./international.svg": 1962,
	"./job.svg": 8989,
	"./language.svg": 6098,
	"./line.svg": 6694,
	"./lineA.svg": 3753,
	"./link.svg": 9098,
	"./list.svg": 8712,
	"./lock.svg": 5344,
	"./log.svg": 795,
	"./logininfor.svg": 7485,
	"./message.svg": 277,
	"./money.svg": 6427,
	"./monitor.svg": 5633,
	"./nested.svg": 8026,
	"./number.svg": 4173,
	"./online.svg": 6977,
	"./password.svg": 2983,
	"./pdf.svg": 7087,
	"./people.svg": 9128,
	"./peoples.svg": 3508,
	"./phone.svg": 7892,
	"./point.svg": 896,
	"./pointA.svg": 6113,
	"./polygon.svg": 4989,
	"./polygonA.svg": 215,
	"./post.svg": 2568,
	"./qq.svg": 5796,
	"./question.svg": 9042,
	"./radio.svg": 6114,
	"./rate.svg": 7574,
	"./rectangle.svg": 378,
	"./rectangleA.svg": 2260,
	"./redis.svg": 4896,
	"./remoke.svg": 486,
	"./row.svg": 3629,
	"./search.svg": 2722,
	"./select.svg": 4238,
	"./server.svg": 2800,
	"./shopping.svg": 6665,
	"./size.svg": 301,
	"./skill.svg": 56,
	"./slider.svg": 7365,
	"./star.svg": 7756,
	"./swagger.svg": 5894,
	"./switch.svg": 7045,
	"./system.svg": 3999,
	"./tab.svg": 3011,
	"./table.svg": 8597,
	"./textarea.svg": 9535,
	"./theme.svg": 4590,
	"./time-range.svg": 6622,
	"./time.svg": 4428,
	"./tool.svg": 7841,
	"./tree-table.svg": 6405,
	"./tree.svg": 6119,
	"./upload.svg": 5182,
	"./user.svg": 9058,
	"./validCode.svg": 9149,
	"./wechat.svg": 8819,
	"./zip.svg": 8328
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2007;